var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.686 2 2 4.685 2 7.995a5.998 5.998 0 0 0 6 5.996c3.314 0 6-2.685 6-5.996A5.998 5.998 0 0 0 8 2ZM0 7.995A7.998 7.998 0 0 1 8 0c4.418 0 8 3.58 8 7.995a7.998 7.998 0 0 1-8 7.996c-4.418 0-8-3.58-8-7.996Zm8-3.998a1 1 0 0 1 1 1v2.584l1.707 1.706A1 1 0 0 1 9.293 10.7l-2-1.998A.997.997 0 0 1 7 8.002V4.997a1 1 0 0 1 1-1Z"
  })));
};
export default SvgClock;